var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 66,
    viewBox: "0 0 65 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_151_1507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.4062 27.6208C50.5646 18.277 42.3583 11.2625 32.5 11.2625C24.6729 11.2625 17.875 15.7041 14.4896 22.2041C6.3375 23.0708 0 29.977 0 38.3458C0 47.3104 7.28542 54.5958 16.25 54.5958H51.4583C58.9333 54.5958 65 48.5291 65 41.0541C65 33.9041 59.4479 28.1083 52.4062 27.6208ZM51.4583 49.1791H16.25C10.2646 49.1791 5.41667 44.3312 5.41667 38.3458C5.41667 32.7937 9.56042 28.1625 15.0583 27.5937L17.9562 27.2958L19.3104 24.7229C21.8833 19.7666 26.9208 16.6791 32.5 16.6791C39.5958 16.6791 45.7167 21.7166 47.0979 28.677L47.9104 32.7395L52.0542 33.0375C56.2792 33.3083 59.5833 36.8562 59.5833 41.0541C59.5833 45.5229 55.9271 49.1791 51.4583 49.1791ZM21.6667 35.6375H28.5729V43.7625H36.4271V35.6375H43.3333L32.5 24.8041L21.6667 35.6375Z",
    fill: "#F07536",
    fillOpacity: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_151_1507"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 65,
    fill: "white",
    transform: "translate(0 0.429199)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUpload);
export default __webpack_public_path__ + "static/media/cloud_upload.ff431a669306af414f6ee8e01b06b85c.svg";
export { ForwardRef as ReactComponent };